/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR) */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCompany } from '../../context/CompanyContext';
import { useTranslation } from '../../hooks/useTranslation';
import { Alert } from './Alert';

interface BoundaryProps {
  children: React.ReactNode;
  resetKey: string;
  copy: { title: string; message: string; reloadWarning: string; reload: string };
  onReload: () => void;
}

/** The shell stays outside this boundary; navigation and company changes can recover. */
export class PageRuntimeContentBoundary extends React.Component<BoundaryProps, { failed: boolean; resetKey: string }> {
  state = { failed: false, resetKey: this.props.resetKey };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  static getDerivedStateFromProps(props: BoundaryProps, state: { resetKey: string }) {
    return props.resetKey !== state.resetKey ? { failed: false, resetKey: props.resetKey } : null;
  }

  componentDidCatch() {
    // Never project/log the raw exception, stack, customer payload or failed URL.
    console.error('[UI_PAGE_RENDER_FAILED]');
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const { copy, onReload } = this.props;
    return (
      <div className="page-container">
        <Alert type="error" dismissible={false}>
          <h2>{copy.title}</h2>
          <p>{copy.message}</p>
          <p>{copy.reloadWarning}</p>
          <button type="button" className="btn-secondary" onClick={onReload}>{copy.reload}</button>
        </Alert>
      </div>
    );
  }
}

export function PageRuntimeBoundary({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { selectedCompanyId } = useCompany();
  const t = useTranslation();
  return (
    <PageRuntimeContentBoundary
      resetKey={JSON.stringify([selectedCompanyId ?? '', location.key])}
      copy={{
        title: t.common.pageUnavailableTitle,
        message: t.common.pageUnavailableMessage,
        reloadWarning: t.common.pageReloadWarning,
        reload: t.dataTable?.refreshLabel ?? t.common?.refresh ?? 'Reload',
      }}
      onReload={() => window.location.reload()}
    >{children}</PageRuntimeContentBoundary>
  );
}
